import { c as _c } from "react/compiler-runtime";
import React from "react";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import Link from "next/link";
import { Tooltip } from "react-tooltip";
import { ApiDropRater } from "@/generated/models/ApiDropRater";
import DropVoteProgressing from "@/components/drops/view/utils/DropVoteProgressing";
import { ApiDropContextProfileContext } from "@/generated/models/ApiDropContextProfileContext";
interface MemesLeaderboardDropVoteSummaryProps {
  readonly current: number;
  readonly projected: number;
  readonly creditType: string;
  readonly ratersCount: number;
  readonly topVoters: ApiDropRater[];
  readonly userContext?: ApiDropContextProfileContext | null;
}
const MemesLeaderboardDropVoteSummary: React.FC<MemesLeaderboardDropVoteSummaryProps> = t0 => {
  const $ = _c(36);
  const {
    current,
    projected,
    creditType,
    ratersCount,
    topVoters,
    userContext
  } = t0;
  const isPositive = current >= 0;
  const hasUserVoted = userContext?.rating !== undefined && userContext?.rating !== 0;
  const userVote = userContext?.rating ?? 0;
  const isUserVoteNegative = userVote < 0;
  const t1 = `tw-font-bold tw-font-mono tw-tracking-tight tw-text-sm ${isPositive ? "tw-text-emerald-500" : "tw-text-rose-500"}`;
  let t2;
  if ($[0] !== current) {
    t2 = formatNumberWithCommas(current);
    $[0] = current;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = <span className={t1}>{t2}</span>;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== current || $[6] !== projected) {
    t4 = <DropVoteProgressing current={current} projected={projected} />;
    $[5] = current;
    $[6] = projected;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== creditType) {
    t5 = <span className="tw-text-iron-500 tw-text-sm tw-ml-1">{creditType} total</span>;
    $[8] = creditType;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== hasUserVoted || $[11] !== isUserVoteNegative || $[12] !== userVote) {
    t6 = hasUserVoted && <span className="tw-hidden @[500px]:tw-inline tw-text-xs tw-text-iron-500 tw-font-mono tw-ml-3 tw-border-l tw-border-solid tw-border-white/10 tw-pl-3 tw-border-t-0 tw-border-r-0 tw-border-b-0">Your vote:{" "}<span className="tw-text-white tw-font-bold">{isUserVoteNegative && "-"}{formatNumberWithCommas(Math.abs(userVote))}</span></span>;
    $[10] = hasUserVoted;
    $[11] = isUserVoteNegative;
    $[12] = userVote;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t3 || $[15] !== t4 || $[16] !== t5 || $[17] !== t6) {
    t7 = <div className="tw-flex tw-items-center tw-gap-2 tw-text-sm">{t3}{t4}{t5}{t6}</div>;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== topVoters) {
    t8 = topVoters.map(_temp2);
    $[19] = topVoters;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t8) {
    t9 = <div className="tw-flex tw-items-center -tw-space-x-2">{t8}</div>;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== ratersCount) {
    t10 = formatNumberWithCommas(ratersCount);
    $[23] = ratersCount;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  const t11 = ratersCount === 1 ? "voter" : "voters";
  let t12;
  if ($[25] !== t11) {
    t12 = <span className="tw-text-iron-500 tw-font-normal">{t11}</span>;
    $[25] = t11;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t10 || $[28] !== t12) {
    t13 = <span className="tw-text-white tw-font-bold tw-text-sm">{t10}{" "}{t12}</span>;
    $[27] = t10;
    $[28] = t12;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== t13 || $[31] !== t9) {
    t14 = <div className="tw-hidden @[700px]:tw-flex tw-items-center tw-gap-2">{t9}{t13}</div>;
    $[30] = t13;
    $[31] = t9;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== t14 || $[34] !== t7) {
    t15 = <div className="tw-flex @[700px]:tw-flex-1 tw-items-center tw-gap-4 @[700px]:tw-justify-between">{t7}{t14}</div>;
    $[33] = t14;
    $[34] = t7;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  return t15;
};
export default MemesLeaderboardDropVoteSummary;
function _temp(e) {
  return e.stopPropagation();
}
function _temp2(voter) {
  return <React.Fragment key={voter.profile.handle}><Link href={`/${voter.profile.handle}`} onClick={_temp} data-tooltip-id={`voter-${voter.profile.handle}`}>{voter.profile.pfp ? <img className="tw-w-6 tw-h-6 tw-rounded-md tw-border-2 tw-border-solid tw-border-[#111] tw-bg-iron-800 tw-object-contain" src={voter.profile.pfp} alt="Recent voter" /> : <div className="tw-w-6 tw-h-6 tw-rounded-lg tw-border-2 tw-border-solid tw-border-[#111] tw-bg-iron-800" />}</Link><Tooltip id={`voter-${voter.profile.handle}`} place="top" offset={8} opacity={1} style={{
      padding: "4px 8px",
      background: "#37373E",
      color: "white",
      fontSize: "13px",
      fontWeight: 500,
      borderRadius: "6px",
      boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
      zIndex: 99999,
      pointerEvents: "none"
    }}>{voter.profile.handle} - {formatNumberWithCommas(voter.rating)}</Tooltip></React.Fragment>;
}